import serverVars from 'server-vars';

export const isBot = (): boolean =>
    serverVars.get('enablers.newBotStandard')
        ? !!serverVars.get('botType')
        : serverVars.get('btdtctd') === 'true';
